/**
 * Validator para o campo social_networks_widget.
 * Valida que cada item tem rede e URL preenchidos.
 */

interface SocialNetworkItem {
  '@id'?: string;
  social_network?: string;
  social_network_url?: string;
}

export const socialNetworksWidgetValidator = ({
  value,
}: {
  value?: { items?: SocialNetworkItem[] };
  formatMessage: (descriptor: { id: string; defaultMessage: string }) => string;
}): string[] | null => {
  const items = value?.items;
  if (!Array.isArray(items) || items.length === 0) return null;

  const hasErrors = items.some(
    (item) => !item.social_network || !item.social_network_url,
  );

  if (!hasErrors) return null;

  return ['All social network entries must have a network type and URL.'];
};

export default socialNetworksWidgetValidator;
